import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from './firebase';
import { Container, Card, CardContent, CardMedia, Typography, Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';

const EventDetail = () => {
  const { id } = useParams();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const fetchEvent = async () => {
      const eventRef = doc(firestore, 'events', id);
      const eventDoc = await getDoc(eventRef);
      if (eventDoc.exists()) {
        const eventData = eventDoc.data();
        
        // Convert Firestore timestamps to JS Date objects if necessary
        if (eventData.startTime && eventData.startTime.toDate) {
          eventData.startTime = eventData.startTime.toDate();
        }
        if (eventData.endTime && eventData.endTime.toDate) {
          eventData.endTime = eventData.endTime.toDate();
        }
        
        setEvent(eventData);
      } else {
        console.log('No such event!');
      }
      setLoading(false);
    };

    fetchEvent();
  }, [id]);

  const handleOpenDialog = () => setOpenDialog(true);
  const handleCloseDialog = () => setOpenDialog(false);

  if (loading) {
    return <div>Loading...</div>;
  }

  return event ? (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Card 
          sx={{ 
            maxWidth: 500, 
            margin: '20px', 
            cursor: 'pointer', 
            transition: 'transform 0.3s ease, box-shadow 0.3s ease', 
            '&:hover': { transform: 'scale(1.05)', boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)' }
          }}
        >
          <CardMedia
            component="img"
            height="200"
            image={event.flyerUrl}
            alt={event.eventName}
          />
          <CardContent>
            <Typography variant="h5" component="div">
              {event.eventName}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {moment(event.startTime).format('DD MMM, YYYY, h:mm A')} - {moment(event.endTime).format('h:mm A')} | {event.venue}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              {event.freePaid} | {event.onlineOffline}
            </Typography>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleOpenDialog}
              sx={{ marginTop: '10px' }}
            >
              View Details
            </Button>
          </CardContent>
        </Card>
      </Box>

      {/* Event Details Dialog */}
      <Dialog 
        open={openDialog} 
        onClose={handleCloseDialog} 
        fullWidth 
        maxWidth="sm"
        PaperProps={{
          style: { padding: '20px', minWidth: '300px', maxWidth: '600px', width: '100%' },
        }}
      >
        <DialogTitle>
          {event.eventName}
          <IconButton 
            onClick={handleCloseDialog}
            style={{ position: 'absolute', top: 8, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <img 
            src={event.flyerUrl} 
            alt={event.eventName} 
            style={{ width: '100%', maxHeight: '200px', objectFit: 'contain', marginBottom: '20px' }} 
          />
          <Typography variant="body1" gutterBottom>
            {moment(event.startTime).format('DD MMM, YYYY, h:mm A')} - {moment(event.endTime).format('h:mm A')} | {event.venue}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {event.description}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Free/Paid: {event.freePaid}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Online/Offline: {event.onlineOffline}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Speaker Name: {event.speakerName}
          </Typography>
          <Typography variant="body2" color="textSecondary" gutterBottom>
            Additional Points: {event.additionalPoints}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  ) : (
    <div>Event not found!</div>
  );
};

export default EventDetail;
